import { IGroupRelationship } from '../../interfaces/igroup-relationship';
import { DrillGroup } from '../drill-group';
import { FracGroup } from '../frac-group';
import { FracGroupSisterPad } from '../frac-group-sister-pad';
import { ScheduleRelationshipType } from '../schedule-relationship-type';

export class GroupRelationshipBase {
  GroupRelationshipId: number;
  FromDrillGroupId: number | null;
  ToDrillGroupId: number | null;
  FromFracGroupId: number | null;
  ToFracGroupId: number | null;
  FracGroupSisterPadId: number | null;
  MinLagDays: number;
  MaxLagDays: number;
  IsCustom: boolean;
  ScenarioId: number;
  ScheduleRelationshipTypeId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FracGroupSisterPad?: FracGroupSisterPad;
  ScheduleRelationshipType?: ScheduleRelationshipType;
  FromDrillGroup?: DrillGroup;
  FromFracGroup?: FracGroup;
  ToDrillGroup?: DrillGroup;
  ToFracGroup?: FracGroup;

  constructor(item?: IGroupRelationship) {
    if (item) {

      this.GroupRelationshipId = item.GroupRelationshipId;
      this.FromDrillGroupId = item.FromDrillGroupId;
      this.ToDrillGroupId = item.ToDrillGroupId;
      this.FromFracGroupId = item.FromFracGroupId;
      this.ToFracGroupId = item.ToFracGroupId;
      this.FracGroupSisterPadId = item.FracGroupSisterPadId;
      this.MinLagDays = item.MinLagDays;
      this.MaxLagDays = item.MaxLagDays;
      this.IsCustom = item.IsCustom;
      this.ScenarioId = item.ScenarioId;
      this.ScheduleRelationshipTypeId = item.ScheduleRelationshipTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FracGroupSisterPad = new FracGroupSisterPad(item.FracGroupSisterPad);
      this.ScheduleRelationshipType = new ScheduleRelationshipType(item.ScheduleRelationshipType);
      this.FromDrillGroup = new DrillGroup(item.FromDrillGroup);
      this.FromFracGroup = new FracGroup(item.FromFracGroup);
      this.ToDrillGroup = new DrillGroup(item.ToDrillGroup);
      this.ToFracGroup = new FracGroup(item.ToFracGroup);
    }
  }
}